module.exports = __webpack_public_path__ + "static/media/anniu1_hui.79aa397d.png";